module.exports = __webpack_public_path__ + "img/1522549714.7d3a940f.jpg";